
const home = {
  // Header nav
  nav_top: 'トップ',
  nav_about: 'DRAとは',
  nav_dreamcode: 'DREAM CODE',
  nav_cases: '導入事例',
  nav_implementation: '導入について',
  nav_awards: '受賞・活動',
  nav_contact: 'CONTACT',
  nav_contact_sub: 'お問い合わせ',

  // Hero
  hero_badge: 'International Education Excellence Award – New York',
  hero_title: '人間の可能性を、\n科学と教育の構造で解き明かす。',
  hero_subtitle: 'DREAM CODEは、\n成長を構造から設計する教育フレームワークです。',
  hero_cta: 'DREAM CODEとは',

  // About
  about_label: 'ABOUT DRA',
  about_title: '構造を扱う教育機関',
  about_body1: 'Dream Realization Academy（DRA）は、\n人間の思考と行動の仕組みを科学的視座から整理し、\n再現可能な教育体系として提示する機関です。',
  about_body2: '私たちは、動機づけではなく構造を扱います。',
  about_body3: '努力が偶然に左右されない社会へ。',
  about_cta: 'DRAとは',

  // Dream Code
  dreamcode_title: '理解で終わらせない。\n体験によって定着させる。',
  dreamcode_body: '全48講座から成る体系的教育プログラム。\n学ぶ、体験する、振り返る、定着させる循環設計により、\n持続的な変化を生み出します。',
  dreamcode_cta: 'DREAM CODEを見る',

  // Four Stages
  stage1_title: '基盤形成',
  stage1_subtitle: '自己理解',
  stage1_desc: '自己の思考パターンと行動の構造を科学的に理解し、成長の土台を構築します。',
  stage2_title: '再構築',
  stage2_subtitle: '思考再設計',
  stage2_desc: '既存の思考フレームを解体し、より効果的な認知構造へと再設計します。',
  stage3_title: '未来設計',
  stage3_subtitle: '戦略構築',
  stage3_desc: '明確な目標設定と、それを実現するための具体的な戦略を体系的に構築します。',
  stage4_title: '自律発展',
  stage4_subtitle: '持続的成長',
  stage4_desc: '自己修正機能を内在化し、環境変化に適応しながら成長し続ける仕組みを確立します。',

  // Application
  app_label: 'APPLICATION AREAS',
  app_title: '適用領域',
  app1_title: '個人',
  app1_desc: 'キャリア形成、自己実現、人生設計における構造的アプローチを提供します。',
  app2_title: '企業',
  app2_desc: '組織開発、リーダーシップ育成、チームビルディングの科学的基盤を構築します。',
  app3_title: '教育機関',
  app3_desc: '学習効果の最大化、教育プログラムの体系化、教員研修の高度化を実現します。',

  // Founder
  founder_title: '創設者メッセージ',
  founder_lead: '私たちは、なぜ「構造」を扱うのか。',
  founder_role: 'Dream Realization Academy 創設者',
  founder_name: '廣瀬進二',

  // Awards
  awards_label: 'GLOBAL RECOGNITION',
  awards_title_sub: '── 世界からの承認',
  awards_body: '2026年、ニューヨーク。国連経済社会理事会・特別協議資格団体より、\n教育と社会発展への功績を讃える「卓越した貢献賞」を授与されました。',
  awards_cta: '詳細はこちら',
  awards_badge_title: 'International Education\nExcellence Award',
  awards_badge_year: 'New York 2026',

  // CTA
  cta_individual: '個人で検討する',
  cta_corporate: '導入について相談する',

  // Footer sections
  footer_about_title: 'DRAについて',
  footer_about_link1: 'DRAとは',
  footer_about_link2: '創設者',
  footer_about_link3: '理念',
  footer_program_title: 'プログラム',
  footer_program_link1: '48講座一覧',
  footer_program_link2: '導入事例',
  footer_intro_title: '導入',
  footer_intro_link1: '個人向け',
  footer_intro_link2: '法人向け',
  footer_intro_link3: '教育機関向け',
  footer_other_title: 'その他',
  footer_other_link1: '受賞・活動',
  footer_other_link2: 'お問い合わせ',
  footer_other_link3: 'プライバシーポリシー',
};

export default home;
